import LoadingIndicator from "./LoadingIndicator";
import * as userActions from "../actions/user";
import {connect} from "redux-vue";
import ValidatedComponent from "./ValidatedComponent";
import Validator from "validatorjs";
import ApiError from "./ApiError";

const ProfileEditForm = {
  props: ['user', 'app', 'uploadPhoto', 'editProfile'],

  data() {
    const [firstname, lastname] = this.user.model.name.split(" ");

    return {
      formData: {
        firstname,
        lastname,
        email: this.user.model.email,
        avatar: this.user.model.avatar,
        mobile: this.user.model.mobile,
        role: this.user.model.role,
        role_name: this.user.model.role_name,
        country_id: this.user.model.country_id,
      },
      formRules: {
        firstname: "required|max:30",
        lastname: "required|max:30",
        email: "required|email",
        country_id: "required",
        role: "required",
        role_name: "",
      },
      formErrors: null,
      formLabels: {
        firstname: this.$t('profile_edit_page.first_name_label'),
        lastname: this.$t('profile_edit_page.last_name_label'),
        email: this.$t('profile_edit_page.email_label'),
        country_id: this.$t('profile_edit_page.country_label'),
        role: this.$t('profile_edit_page.role_label'),
        role_name: this.$t('profile_edit_page.role_name_label'),
      }
    }
  },

  computed: {
    roleNameVisible() {
      const otherRole = this.app.roles.find(
        i => i.role.toLowerCase() === "other"
      );
      return otherRole && otherRole.id === this.formData.role;
    }
  },

  watch: {
    user (nextVal, val) {
      if (val.photoUpload && !nextVal.photoUpload) {
        if (this.$refs.aviInput) {
          this.$refs.aviInput.value = "";
        }
      }

      if (val.edit && nextVal.editSuccess) {
        const [firstname, lastname] = this.user.model.name.split(" ");

        this.formData = {
          firstname,
          lastname,
          email: this.user.model.email,
          avatar: this.user.model.avatar,
          mobile: this.user.model.mobile,
          role: this.user.model.role,
          role_name: this.user.model.role_name,
          country_id: this.user.model.country_id,
        };
      }
    }
  },
  
  methods: {
    /**
     *
     */
    onAvatarEditClick () {
      this.$refs.aviInput && this.$refs.aviInput.click();
    },

    /**
     *
     * @param event
     */
    uploadProfileAvatar (event) {
      if (event.target.files.length && !this.user.photoUpload) {
        const data = new FormData();
        data.append("photo", event.target.files[0]);

        this.uploadPhoto(data);
      }
    },

    /**
     *
     * @param event
     * @returns {Promise<void>}
     */
    async onSubmitPress (event) {
      event.preventDefault();

      if (this.roleNameVisible) {
        this.formRules.role_name = "required";
      } else {
        this.formRules.role_name = "";
      }

      const validation = new Validator(this.formData, this.formRules);

      validation.setAttributeFormatter((attribute) =>
        this.formLabels[attribute].toLowerCase()
      );

      if (validation.passes()) {
        this.formErrors = null;

        const data = {
          name: [this.formData.firstname, this.formData.lastname].join(" "),
          email: this.formData.email,
          mobile: this.formData.mobile,
          role: this.formData.role,
          role_name: this.roleNameVisible ? this.formData.role_name : null,
          country_id: this.formData.country_id,
        };

        await this.editProfile(data);
        Snackbar.show({
          text: this.$t('saved'),
          actionText: this.$t('dismiss'),
        });
      } else {
        this.formErrors = validation.errors.all();
      }

    }
  },

  /**
   * 
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <form action="#">
        <div class="p-3 lg:p-12 lg:pr-0">
          <p class="font-bold text-base mb-5">
            {this.$t('profile_edit_page.profile')}
          </p>

          <div class="flex flex-col-reverse lg:flex-row">
            <div class="lg:w-7/12">
              <div class="lg:w-9/12">
                <div class="flex flex-wrap lg:-mx-5">
                  <div class="w-full lg:w-6/12 lg:px-5">
                    <div class="mb-4">
                      <label class="block text-gray-700 text-sm mb-2" for="firstname">
                        {this.formLabels.firstname}
                      </label>
                      <ValidatedComponent
                        name="firstname"
                        errors={this.formErrors}
                        renderComponent={classname => (
                          <input
                            class={"bg-gray-200 text-sm appearance-none border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline " + classname}
                            id="firstname" type="text" v-model={this.formData.firstname}/>
                        )}
                      />
                    </div>
                  </div>
                  <div class="w-full lg:w-6/12 lg:px-5">
                    <div class="mb-4">
                      <label class="block text-gray-700 text-sm mb-2" for="surname">
                        {this.formLabels.lastname}
                      </label>
                      <ValidatedComponent
                        name="lastname"
                        errors={this.formErrors}
                        renderComponent={classname => (
                          <input
                            class={"bg-gray-200 text-sm appearance-none border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline " + classname}
                            id="lastname" type="text" v-model={this.formData.lastname}/>
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="lg:w-5/12">
                <div class="mb-4">
                  <label class="block text-gray-700 text-sm mb-2" for="country">
                    {this.formLabels.country_id}
                  </label>
                  <ValidatedComponent
                    name="country"
                    errors={this.formErrors}
                    classname="block appearance-none w-full bg-gray-200 text-sm border text-gray-700 p-2 rounded leading-tight focus:outline-none focus:shadow-outline"
                    renderComponent={classname => (
                      <div class="relative">
                        <select
                          class={classname}
                          id="country"
                          v-model={this.formData.country_id}
                        >
                          <option selected disabled value=""></option>
                          {this.app.countries.map(i => (
                            <option value={i.id} key={i.id}>
                              {i.country}
                            </option>
                          ))}
                        </select>
                        <div
                          class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                          <i class="mdi mdi-chevron-down"></i>
                        </div>
                      </div>
                    )}
                  />
                </div>
              </div>
              <div class="lg:w-5/12">
                <div class="mb-4">
                  <label class="block text-gray-700 text-sm mb-2" for="role">
                    {this.formLabels.role}
                  </label>
                  <ValidatedComponent
                    name="role"
                    errors={this.formErrors}
                    classname="block appearance-none w-full bg-gray-200 text-sm border text-gray-700 p-2 rounded leading-tight focus:outline-none focus:shadow-outline"
                    renderComponent={classname => (
                      <div class="relative">
                        <select
                          class={classname}
                          id="role"
                          v-model={this.formData.role}
                        >
                          <option selected disabled value=""></option>
                          {this.app.roles.map(i => (
                            <option value={i.id} key={i.id}>
                              {i.role}
                            </option>
                          ))}
                        </select>
                        <div
                          class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                          <i class="mdi mdi-chevron-down"></i>
                        </div>
                      </div>
                    )}
                  />
                </div>
                {this.roleNameVisible && (
                  <div class="mb-4">
                    <label class="block text-gray-700 text-sm mb-2" for="role_name">
                      {this.formLabels.role_name}
                    </label>
                    <ValidatedComponent
                      name="role_name"
                      errors={this.formErrors}
                      renderComponent={classname => (
                        <input
                          class={"bg-gray-200 text-sm appearance-none border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline " + classname}
                          id="role_name" type="text" v-model={this.formData.role_name}/>
                      )}
                    />
                  </div>
                )}
              </div>
              <div class="flex flex-col lg:flex-row">
                <div class="lg:w-5/12 lg:mr-8">
                  <div class="mb-4">
                    <label class="block text-gray-700 text-sm mb-2" for="email">
                      {this.formLabels.email}
                    </label>
                    <ValidatedComponent
                      name="email"
                      errors={this.formErrors}
                      renderComponent={classname => (
                        <input
                          class={'bg-gray-200 text-sm appearance-none border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline' + classname}
                          id="email" type="email" v-model={this.formData.email}/>
                      )}
                    />
                  </div>
                </div>
                <div class="w-1/2 lg:w-3/12">
                  <div class="mb-4">
                    <label class="block text-gray-700 text-sm mb-2" for="mobile">
                      {this.$t('profile_edit_page.mobile_phone_label')}
                    </label>
                    <ValidatedComponent
                      name="mobile"
                      errors={this.formErrors}
                      renderComponent={classname => (
                        <input
                          class={'bg-gray-200 text-sm appearance-none border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ' + classname}
                          id="mobile" type="tel" v-model={this.formData.mobile}/>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="lg:w-5/12">
              <p class="text-base mb-4 border-b-2 pb-1">
                <span class="lg:hidden">{this.$t('profile_edit_page.profile')}</span>
                {' '}{this.$t('photo')}
              </p>

              <div class="mb-10">
                <div class="flex items-center">
                  <div class="h-20 w-20 rounded-full overflow-hidden mr-5 bg-gray-200 relative">
                    <div class="absolute h-full w-full rounded-full z-0">
                      <div class="flex items-center justify-center">
                        <i class="mdi mdi-account text-gray-800 text-5xl"></i>
                      </div>
                    </div>
                    <img src={process.env.VUE_APP_BASE + "/" + this.user.model.avatar} alt="" class="h-full w-full relative z-20"/>
                  </div>
                  <button
                    class="px-3 p-1 rounded-full focus:outline-none focus:shadow-outline text-xs border-orange-600 border-2 "
                    type="button"
                    onClick={this.onAvatarEditClick}
                    disabled={this.user.photoUpload}
                  >
                    {this.user.photoUpload && <LoadingIndicator fill="#000"/>}
                    {this.user.photoUpload || (
                      <fragment>
                        <i class="mdi mdi-upload mr-2"></i>
                        {this.$t('upload_new')}...
                      </fragment>
                    )}
                  </button>
                  <input type="file" ref="aviInput" accept="image/png,image/gif,image/jpeg" onChange={this.uploadProfileAvatar} class="hidden"/>
                </div>
              </div>
            </div>
          </div>

          <ApiError error={this.user.editError}/>

          <div class="flex flex-col lg:flex-row items-start lg:items-center mt-4 lg:my-10">
            <button
              class="px-3 lg:px-5 py-2 lg:py-3 mr-3 lg:mr-5 mb-3 lg:mb-0 rounded-full bg-action hover:bg-action-dark focus:outline-none text-base text-white"
              type="submit" onClick={this.onSubmitPress}>
              {this.user.edit && <LoadingIndicator />}
              {this.user.edit || (
                <fragment>
                  {this.$t('profile_edit_page.save_changes')}
                  <i class="mdi mdi-arrow-right ml-5"></i>
                </fragment>
              )}
            </button>

            <button type="button" class="focus:outline-none rounded-full text-blue-600 font-bold px-3 lg:px-5 p-2 lg:p-3 text-xs lg:text-base uppercase">
              {this.$t('profile_edit_page.cancel')}
            </button>
          </div>
        </div>
      </form>
    )
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    app: state.app,
  };
}

function mapActionToProps(dispatch) {
  return {
    uploadPhoto: (data) => dispatch(userActions.uploadPhoto(data)),
    editProfile: async (data) => await dispatch(userActions.editProfile(data)),
  };
}

export default connect(mapStateToProps, mapActionToProps)(ProfileEditForm);